/* eslint-disable no-console */
import lambda from './lambda'
import Amplify from '@aws-amplify/core';
import Auth from '@aws-amplify/auth';
import CONFIG from './config'

const ENDPOINT = `https://lambda.${CONFIG.region}.amazonaws.com/2015-03-31/functions/`
const REGION = CONFIG.region

Amplify.configure({
    Auth: CONFIG,
    API: {
        endpoints: [
            {
                name: 'lambda',
                endpoint: ENDPOINT,
                service: 'lambda',
                region: REGION
            }
        ]
    }
})

window.removeUser = () => {
    Auth.currentAuthenticatedUser().then((user) => {
        user.deleteUser((err, result) => {
            if (err) console.error(err.message || JSON.stringify(err))
            console.info('call result: ' + result)
        })
    }).catch(err => console.error(err))
}

export { lambda, CONFIG }
